import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Viewveteran() {
  return (
    <section className="view_veteran p-100 text_veteran">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>Solution</h2>
            <p>
              The Veteran Job & Career Portal – Search For What Interests You!
            </p>
          </Col>
        </Row>
        <Row className="pt-md-5 pt-2">
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="new_img">
              <StaticImage
                src="../../../images/case-studies/veteran-app/view_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={616}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>Easy To View Listings, Category Search & Much More</h2>
            <p>
              We knew that if we have to bring value to the Veteran App, it had
              to offer Veterans with the chance to restart their career in
              avenues that interest them the most. This need is served in the
              app through a specialized Career & Job Portal where Veterans can
              search for jobs or work opportunities through easy to understand
              categories.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Viewveteran;
